import Reflux from "reflux";
import { singletonActions } from "logic/singleton";
const EntityShareActions = singletonActions(
  "permissions.EntityShare",
  () => Reflux.createActions({
    prepare: { asyncResult: true },
    update: { asyncResult: true },
    loadUserSharesPaginated: { asyncResult: true }
  })
);
export default EntityShareActions;
